/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useMemo, useLayoutEffect } from "react";
import get from "lodash/get";
import { StoryElement, WithLazy } from "@quintype/components";

import Tags from "../story-elements/tags";
import AlsoRead from "../story-elements/also-read";
import Slideshow from "../story-elements/slide-show";
import Attachment from "../story-elements/attachment";
import FactCheckView from "../story-elements/fact-check";
import ImageGallery from "../story-elements/image-gallery";
import MovieReviewView from "../story-elements/movie-review";
import GadgetReviewView from "../story-elements/gadget-review";
import ReferenceElement from "../story-elements/reference-element";
import BookReviewView from "../story-elements/book-review";
import SubscribeCard from "../../molecules/subscribe-card";
import PublishedAt from "./published-at";
import { getHeroOverrideElement } from "../../helper/utils";

// import SectionStories from "./section-stories";

import { AdContainer } from "../../ads";
import TaboolaAd from "../../ads/taboola-ad";

import BlockQuoteIcon from "../../atoms/icons/blockquote-icon";
import QuoteIcon from "../../atoms/icons/quote-icon";
import PromotionalMessage from "./promotional-message";
import ImagewithCaption from "../../molecules/Image-caption";
import ImagewithCaptionWithoutShare from "../../molecules/image-without-share";

import { getPrimaryEmbed } from "../story-header/embed-element";

import "./story-elements.m.css";
import QandA from "./q-and-a";
import useAdType from "../../helper/useAdType";
import ElectionBrickWall from "../../molecules/election-brick-wall";
import {
  assemblyElection2024ConstituencyData,
  assemblyElection2024SlugData_Delhi,
  assemblyElection2025SlugData_Bihar,
  assemblyElection2024SlugData,
  assemblyElection2024SlugData_JK_HR
} from "../../molecules/election-brick-wall-with-search/election-data-2024";
import { useSelector } from "react-redux";
import { throttle } from "lodash";
import DownArrow from "../../atoms/other-icons/DownArrow";
// import CustomWidget from "../../atoms/custom-widget";
import NewBodyWidget from "../../atoms/new-body-banner";
import PaywallCard from "../../molecules/paywall";
import { SpinnerLoader } from "../../common/loader";
import { ADFREE_STORY_SLUGS } from "../../../constants";

const getParagraphsFromHtml = (html) => {
  if (!html) return [];
  const regex = /<([a-zA-Z0-9]+)\b[^>]*>([\s\S]*?)<\/\1>/g;
  const paragraphs = [];
  let match;
  while ((match = regex.exec(html)) !== null) {
    paragraphs.push(match[0]);
  }
  if (paragraphs.length === 0 && html.trim()) {
    paragraphs.push(html);
  }
  return paragraphs;
};

const countWordsInHtml = (html) => {
  if (!html) return 0;
  const cleanText = html.replace(/<[^>]*>/g, " ").trim();
  if (!cleanText) return 0;
  return cleanText.split(/\s+/).filter(Boolean).length;
};

const truncateHtmlAtWordBoundary = (html, wordLimit) => {
  if (!html || wordLimit <= 0) return "";

  const parser = new DOMParser();
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  let wordCount = 0;
  let truncated = false;

  const traverse = (node) => {
    if (truncated) return;

    if (node.nodeType === 3) { // TEXT_NODE
      const text = node.textContent;
      const words = text.match(/\S+/g) || [];

      if (wordCount + words.length >= wordLimit) {
        // This text node contains our word limit
        const remainingWords = wordLimit - wordCount;
        let charIndex = 0;
        let currentWord = 0;

        // Find the character position of the remaining words
        for (let i = 0; i < text.length && currentWord < remainingWords; i++) {
          if (/\S/.test(text[i])) {
            if (i === 0 || /\s/.test(text[i - 1])) {
              currentWord++;
            }
          }
          charIndex = i + 1;
        }

        node.textContent = text.substring(0, charIndex);
        truncated = true;
      } else {
        wordCount += words.length;
      }
    } else if (node.nodeType === 1) { // ELEMENT_NODE
      const childNodes = Array.from(node.childNodes);
      for (let child of childNodes) {
        traverse(child);
        if (truncated) {
          // Remove all siblings after the current node
          const idx = node.childNodes.length - 1;
          while (node.childNodes.length > idx + 1) {
            node.removeChild(node.lastChild);
          }
          break;
        }
      }
    }
  };

  traverse(tempDiv);
  return tempDiv.innerHTML;
};

const getParagraphsArr = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const elements = [...doc.body.children];
  return elements.map((el) => el.outerHTML);
};

export const countPTags = (el) => {
  const html = el?.text;
  if (!html || typeof html !== "string") return 0;
  if (el?.metadata?.["promotional-message"] === true || el?.metadata?.["promotional-message"] === "true") return 0;

  const matches = html.match(/<p(\s|>)/gi);
  return matches ? matches.length : 0;
};

export const getTotalParaCount = (story) => {
  return (
    story?.cards?.reduce((count, card) => {
      card?.["story-elements"]?.forEach((el) => {
        if (el?.type === "text" && el?.subtype === null && el?.text) {
          count += countPTags(el);
        }
      });
      return count;
    }, 0) ?? 0
  );
};

const getWordCount = (html) => {
  if (typeof DOMParser === "undefined") return 0;
  const doc = new DOMParser().parseFromString(html, "text/html");
  return (doc.body.textContent || "").match(/\S+/g)?.length || 0;
};

const truncateHtmlToWords = (html, wordLimit) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  let wordsRemaining = wordLimit;
  let node;

  while ((node = walker.nextNode())) {
    const words = node.textContent.match(/\S+/g) || [];
    if (words.length <= wordsRemaining) {
      wordsRemaining -= words.length;
      continue;
    }

    const wordEnd = [...node.textContent.matchAll(/\S+/g)][wordsRemaining - 1]?.index;
    const end = wordEnd + words[wordsRemaining - 1].length;
    const range = doc.createRange();
    range.setStart(node, end);
    range.setEnd(doc.body, doc.body.childNodes.length);
    range.deleteContents();
    break;
  }

  return doc.body.innerHTML;
};

const getPremiumCards = (cards, wordLimit = 165) => {
  let wordsRemaining = wordLimit;
  let limitReached = false;

  return cards.reduce((visibleCards, card) => {
    if (limitReached) return visibleCards;

    const visibleElements = [];
    for (const element of card["story-elements"] || []) {
      if (limitReached) break;

      if (wordsRemaining === 0) {
        limitReached = true;
        break;
      }

      if (element.type === "text" && element.text) {
        const isPromotional =
          element.metadata?.["promotional-message"] === true ||
          element.metadata?.["promotional-message"] === "true";
        const isAlsoRead = element.subtype === "also-read";
        if (!isPromotional && !isAlsoRead) {
          const elementWordCount = getWordCount(element.text);
          if (elementWordCount > wordsRemaining) {
            visibleElements.push({ ...element, text: truncateHtmlToWords(element.text, wordsRemaining) });
            wordsRemaining = 0;
            limitReached = true;
            break;
          }
          wordsRemaining -= elementWordCount;
        }
      }

      visibleElements.push(element);
      if (wordsRemaining === 0) limitReached = true;
    }

    if (visibleElements.length) visibleCards.push({ ...card, "story-elements": visibleElements });
    return visibleCards;
  }, []);
};

let countPara = 0;
let hasRenderedMidAd1 = false;
let hasRenderedMidAd2 = false;

const CustomStoryElement = ({ element, elementIndex, adType, story, tempHideAd }) => {
  const rawHtml = element && element.text;
  const [paragraphs, setParagraphs] = useState([]);
  const storyTemplate = story && story["story-template"];
  const blockedTemplates = ["listicle", "live-blog"];
  const totalParaCount = getTotalParaCount(story);

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";

  const tags = story.tags || [];
  const isPremiumStory = story?.access === "subscription";

  useEffect(() => {
    let isWebView = false;
    if (typeof window !== "undefined") {
      const searchparam = window.location.search;
      if (searchparam.includes("app=true")) {
        isWebView = true;
      }
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = rawHtml;
      const paragraphElements = getParagraphsArr(rawHtml);

      const parsedParagraphs =
        paragraphElements &&
        paragraphElements.map((p, index) => {
          const tempElement = document.createElement("div");
          tempElement.innerHTML = p;
          const hasPTag = tempElement.getElementsByTagName("p").length > 0;

          if (hasPTag) {
            countPara = countPara + 1;
          }

          if (
            !blockedTemplates.includes(storyTemplate) &&
            countPara > 0 &&
            countPara === 1 &&
            !hasRenderedMidAd1 &&
            !["listicle", "photo", "news-briefs"].includes(story["story-template"]) &&
            !tempHideAd
          ) {
            hasRenderedMidAd1 = true;

            return (
              <div key={index}>
                <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
                <NewBodyWidget />
                {!isAdfree && <div id={storyTemplate !== "podcast" && "FirstAdContainer"}>
                  {storyTemplate !== "podcast" && (
                    <div styleName="ad-wrapper" className="hide-desktop">
                      <AdContainer
                        storyPageAds={true}
                        AdClassName="standard-336x280"
                        id={adType === "izooto" ? "div-gpt-ad-1711972030627-0" : "div-gpt-ad-1680157855094-0"}
                        mobile={adType === "izooto" ? "DH_MWeb_AT_Mid_ym" : "DH_MWeb_AT_Mid"}
                        isExternalAdPath={adType === "izooto" ? true : false}
                        cta={countPara < totalParaCount ? "inStory" : "sidebar"}
                      />
                    </div>
                  )}
                  <div styleName="ad-wrapper" className="hide-mobile">
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711971649563-0" : "div-gpt-ad-1680156704803-0"}
                      desktop={adType === "izooto" ? "DH_Desktop_AT_Mid_ym" : "DH_Desktop_AT_Mid"}
                      isExternalAdPath={adType === "izooto" ? true : false}
                      cta={countPara < totalParaCount ? "inStory" : "sidebar"}
                    />
                  </div>
                </div>}
              </div>
            );
          }

          if (countPara > 0 && countPara === 4 && !hasRenderedMidAd2) {
            hasRenderedMidAd2 = true;
            return (
              <div key={index}>
                <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
                {!isWebView && !isAdfree && (story["story-template"] === "text" || story["story-template"] === "syndicated" || story["story-template"] === "dh-exclusive") && (
                  <div id="SecondAdContainer">
                    <div styleName="ad-wrapper" className="hide-desktop">
                      <AdContainer
                        storyPageAds={true}
                        AdClassName="standard-336x280"
                        id="div-gpt-ad-1726651118047-0"
                        desktop={false}
                        mobile="DH_MWeb_AT_Mid02"
                        cta={countPara < totalParaCount ? "inStory" : "sidebar"}
                      />
                      {window && window.innerWidth < 767 && <div
                        id="taboola-mid-article-personalisation"
                        styleName="taboola-4u"
                        ref={(el) => {
                          if (!el) return;

                          window._taboola = window._taboola || [];
                          window._taboola.push({
                            mode: "organic-thumbnails-mid-personalisation-mob",
                            container: "taboola-mid-article-personalisation",
                            placement: "Mid Article Personalisation",
                            target_type: "mix",
                          });
                          window._taboola.push({ flush: true });
                        }}
                      />}
                    </div>
                    <div styleName="ad-wrapper" className="hide-mobile">
                      <AdContainer
                        AdClassName="standard-970x90"
                        id="div-gpt-ad-1752820478684-0"
                        desktop="DH_Desktop_AT_LB_Mid"
                        mobile={false}
                        cta={countPara < totalParaCount ? "inStory" : "sidebar"}
                      />
                      {window && window.innerWidth >= 767 && <div
                        id="taboola-mid-article-personalisation-desk"
                        ref={(el) => {
                          if (!el) return;

                          window._taboola = window._taboola || [];
                          window._taboola.push({
                            mode: "organic-thumbnails-mid-personalisation-desk",
                            container: "taboola-mid-article-personalisation-desk",
                            placement: "Mid Article Personalisation",
                            target_type: "mix",
                          });
                          window._taboola.push({ flush: true });
                        }}
                      />}
                    </div>
                  </div>
                )}
              </div>
            );
          }

          return (
            <div key={index}>
              <div className="story-element story-element-text" dangerouslySetInnerHTML={{ __html: p }}></div>
            </div>
          );
        }).filter(Boolean);
      setParagraphs(parsedParagraphs);
    }
  }, [isPremiumStory, isAdfree]);

  return <div>{paragraphs}</div>;
};
const fourthTextStoryElementID = (story) => {
  const textStoryElements = [];
  story.cards.map((element) =>
    element["story-elements"]?.map((element) => {
      if (element.subtype === null && element.type === "text") {
        textStoryElements.push(element);
      }
    })
  );
  return textStoryElements.length > 5 ? textStoryElements[3].id : null;
};

const getElements = (element, story, elementIndex, cardIndex, isImmersiveStory, adType, tempHideAd) => {
  if (!isImmersiveStory) {
    const primaryEmbed = getPrimaryEmbed(story);
    const primaryEmbedId = primaryEmbed?.id ? primaryEmbed.id : null;
    if (
      element.id === primaryEmbedId &&
      (story["story-template"] == "embed" ||
        story["story-template"] == "video-playlist" ||
        story["story-template"] == "podcast")
    ) {
      return null;
    }
  }
  const elementType = element.type;

  if (element.metadata?.["promotional-message"] === true) {
    return null;
  }

  if (element && element.type === "text" && element.subtype === null) {
    return (
      <div id="text-element-with-ad">
        <CustomStoryElement
          element={element}
          elementIndex={elementIndex}
          adType={adType}
          story={story}
          tempHideAd={tempHideAd}
        />
      </div>
    );
  }

  switch (element.subtype) {
    case "attachment": {
      return <Attachment element={element} />;
    }
    case "references": {
      const referenceObj = get(element, ["story-elements"], []);
      return referenceObj.map((element, index) => <ReferenceElement element={element} key={index} />);
    }
    case "image-gallery": {
      if (element.metadata.type === "gallery") {
        return <WithLazy margin="50px">{() => <ImageGallery element={element} story={story} />}</WithLazy>;
      }

      if (element.metadata.type === "slideshow") {
        return <WithLazy margin="50px">{() => <Slideshow story={story} element={element} />}</WithLazy>;
      }
      break;
    }
    case "blockquote": {
      return (
        <div styleName="blockquote-wrapper">
          <BlockQuoteIcon width="40" height="40px" />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "also-read": {
      return <AlsoRead element={element} story={story} isImmersiveStory={isImmersiveStory} />;
    }
    case "quote": {
      return (
        <div styleName="quote-contents" className="exclusive-contents">
          <QuoteIcon />
          <StoryElement element={element} key={element.id} story={story} />
        </div>
      );
    }
    case "q-and-a": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "question": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "answer": {
      return <QandA element={element} story={story} subtype={element.subtype} />;
    }
    case "table": {
      if (element.metadata["has-header"] == true) {
        const updateEle = { ...element };
        updateEle.metadata["has-header"] = false;
        return (
          <div className="has-head story-element story-element-data">
            <StoryElement element={updateEle} key={updateEle.id} story={story} />;
          </div>
        );
      } else {
        return <StoryElement element={element} key={element.id} story={story} />;
      }
    }
    default:
      if (elementType === "image") {
        if (
          story["story-template"] === "photo" ||
          story["story-template"] === "text-new" ||
          story["story-template"] === "sponsored" ||
          story["story-template"] === "brandspot-client-story"
        ) {
          return (
            <div styleName="share-wrapper">
              <StoryElement
                renderTemplates={{ image: ImagewithCaption }}
                element={element}
                key={element.id}
                story={story}
                index={elementIndex}
              />
            </div>
          );
        } else {
          return (
            <StoryElement
              renderTemplates={{ image: ImagewithCaptionWithoutShare }}
              element={element}
              key={element.id}
              story={story}
            />
          );
        }
      } else {
        return (
          <div styleName="share-wrapper">
            {story["story-template"] !== "podcast" || story["story-template"] !== "video-playlist" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : elementType !== "jsembed" ? (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            ) : element.subtype === "" || element.subtype === null ? (
              console.log("element.subtype ignored:>:>:>:>:>", elementType, element.subtype)
            ) : (
              <StoryElement element={element} key={element.id} story={story} loadIframeOnClick />
            )}
          </div>
        );
      }
  }
};

export const StoryCard = ({
  story,
  card,
  cardIndex,
  index,
  isNewTextStory,
  showAlsoReadOnTop = true,
  adType,
  isMobile,
  isImmersiveStory,
  tempHideAd,
}) => {
  const elements = card["story-elements"];
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true";
  const totalParaCount = getTotalParaCount(story);
  const heroImageOverride = story?.["metadata"]?.["story-attributes"]?.["heroimageoverride"]?.[0] === "true";
  const deleteOverrideElement = story?.["metadata"]?.["story-attributes"]?.["deleteoverrideelement"]?.[0] === "true";
  const { component: RenderHeroComponent, elementId: heroElementId } =
    getHeroOverrideElement({
      story,
      heroImageOverride,
    });

  const wrappedAllElementCard = (elements, story, card, cardIndex, adType, isMobile) => {
    let allAlsoReads = [];
    let allWrappedElements = [];

    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      if (element.id === heroElementId && heroImageOverride && deleteOverrideElement) {
        continue;
      }

      if (element.subtype === "also-read") {
        allAlsoReads.push(element);
      } else {
        if (allAlsoReads.length > 1) {
          allWrappedElements.push(
            <div styleName="also-read-main-wrapper">
              {allAlsoReads.map((element, elementIndex) => (
                <AlsoRead
                  story={story}
                  element={element}
                  isConsecutive={true}
                  elementIndex={elementIndex}
                  isImmersiveStory={isImmersiveStory}
                />
              ))}
            </div>
          );
        } else {
          allWrappedElements.push(
            ...allAlsoReads.map((element, elementIndex) => (
              <AlsoRead
                story={story}
                element={element}
                isConsecutive={false}
                elementIndex={elementIndex}
                isImmersiveStory={isImmersiveStory}
              />
            ))
          );
        }

        allAlsoReads = [];
        allWrappedElements.push(getElements(element, story, i, cardIndex, isImmersiveStory, adType, tempHideAd));
      }
    }
    if (allAlsoReads.length > 1) {
      allWrappedElements.push(
        <div styleName="also-read-main-wrapper">
          {allAlsoReads.map((element, elementIndex) => (
            <AlsoRead
              story={story}
              element={element}
              isConsecutive={true}
              elementIndex={elementIndex}
              isImmersiveStory={isImmersiveStory}
            />
          ))}
        </div>
      );
    } else {
      allWrappedElements.push(
        ...allAlsoReads.map((element, elementIndex) => (
          <AlsoRead
            story={story}
            element={element}
            isConsecutive={false}
            elementIndex={elementIndex}
            isImmersiveStory={isImmersiveStory}
          />
        ))
      );
    }
    return allWrappedElements;
  };
  return (
    <div
      styleName={`story-card ${isNewTextStory ? "card-border" : ""}`}
      key={card.id}
      id={card.id}
      className="story-card"
    >
      {wrappedAllElementCard(elements, story, card, cardIndex, adType, isMobile).map((element, elementIndex) => {
        const elementType = element?.props?.children?.props?.element?.type;
        return (
          <React.Fragment key={elementIndex}>
            <React.Fragment>{element}</React.Fragment>
            {/* {fourthTextStoryElementID(story) === element?.id &&
            (story["story-template"] === "text" || story["story-template"] === "syndicated") &&
            story["story-template"] !== "immersive" ? (
              <SectionStories story={story} />
            ) : null} */}
            {cardIndex === 0 &&
              elementIndex === 0 &&
              elementType !== "text" && elementType !== "jsembed" &&
              !["listicle", "photo", "news-briefs", "immersive"].includes(story["story-template"]) &&
              !tempHideAd && !isAdfree ? (
              <>
                <div styleName="ad-wrapper" key={index}>
                  {isMobile ? (
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711972030627-0" : "div-gpt-ad-1680156704803-0"}
                      mobile={adType === "izooto" ? "DH_MWeb_AT_Mid_ym" : "DH_MWeb_AT_Mid"}
                      isExternalAdPath={adType === "izooto" ? true : false}
                      cta={countPara < totalParaCount ? "inStory" : "sidebar"}
                    />
                  ) : (
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711971649563-0" : "div-gpt-ad-1680156704803-0"}
                      desktop={adType === "izooto" ? "DH_Desktop_AT_Mid_ym" : "DH_Desktop_AT_Mid"}
                      isExternalAdPath={adType === "izooto" ? true : false}
                      cta={countPara < totalParaCount ? "inStory" : "sidebar"}
                    />
                  )}
                </div>
              </>
            ) : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const getArticlesRemaining = () => {
  const count = sessionStorage.getItem("articles_remaining");
  if (count === null || count === undefined) return null;
  const parsed = parseInt(count, 10);
  return isNaN(parsed) ? null : parsed;
};

const getUpdatedCards = (cards) => {
  const updatedCards = [];
  let alsoReadElements = [];

  for (let card = 0; card < cards.length; card++) {
    const firstCard = cards[card];
    const secondCard = cards[card + 1];
    const firstCardLastElement = firstCard["story-elements"][firstCard["story-elements"].length - 1];
    const lastCard = cards[cards.length - 1];

    if (firstCardLastElement?.subtype === "also-read" && secondCard) {
      for (let element = 0; element < secondCard["story-elements"].length; element++) {
        if (secondCard["story-elements"][element]?.subtype === "also-read") {
          alsoReadElements.push(secondCard["story-elements"][element]);
        } else {
          break;
        }
      }
      firstCard["story-elements"] = [...firstCard["story-elements"], ...alsoReadElements];
      updatedCards.push(firstCard);
      const updatedsecondCardElements = secondCard["story-elements"].filter(
        (element) => !alsoReadElements.includes(element)
      );
      secondCard["story-elements"] = updatedsecondCardElements;
      if (secondCard.id === lastCard.id) {
        updatedCards.push(secondCard);
      }
    } else {
      if (!updatedCards.includes(firstCard)) {
        updatedCards.push(firstCard);
      }
    }
    alsoReadElements = [];
  }

  return updatedCards;
};

const StoryElements = ({
  story,
  index,
  cards,
  isFactCheck,
  isMovieReview,
  isGadgetReview,
  isBookReview,
  isSponsoredStory,
  isBrandspotClientStory,
  isImmersiveStory,
  isNewTextStory,
  fontSize
}) => {
  const template = story["story-template"] ?? "text";
  const isBrandspotNoAdStory = template === "brandspot-with-no-ad";
  const isSpecificStory = ADFREE_STORY_SLUGS.some(slug => story?.slug?.includes(slug));

  const [isMobile, setIsMobile] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldShowReadMore, setShouldShowReadMore] = useState(false);
  const [storyContentMaxHeight, setStoryContentMaxHeight] = useState(null);
  const [renderTaboolaAd, setRenderTaboolaAd] = useState(false);

  const sponsoredText = story?.["metadata"]?.["story-attributes"]?.["sponsorednote"]?.[0] === "true" && isSponsoredStory;
  const storyContentRef = useRef(null);
  const contentRef = useRef(null);
  const innerContentRef = useRef(null);
  const mainRef = useRef(null);
  // Premium story/paywall logic is disabled in this file.
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const isAdfree = get(qtState, ["config", "subscriber"]) === "true" || isSpecificStory;
  const tags = story.tags || [];
  const isPremiumStory = story?.access === "subscription";
  const [isAuthReloading, setIsAuthReloading] = useState(false);
  const [isSSOCallback, setIsSSOCallback] = useState(false);
  const isUserLogin = get(qtState, ["user", "isLoggedIn"], false);
  const prevIsUserLoginRef = useRef(isUserLogin);
  const [showLoader, setShowLoader] = useState(true);
  const [clipHeight, setClipHeight] = useState(null);


  const adType = useAdType();
  const showBrickWall = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "show_brickWall"], false)
  );

  const tempHideAd =
    template === "brandspot-with-no-ad" ||
    story?.slug?.includes("dhbrandspot-pr/best-crypto-casinos-2025-my-go-to-sites-for-bitcoin-gambling-3470705");

  useEffect(() => {
    if (mainRef.current && isImmersiveStory && fontSize) {
      mainRef.current.style.setProperty("--storyContentFont", `${fontSize}px`);
      mainRef.current.style.setProperty("--base", `${fontSize}px`);
    }
  }, [isImmersiveStory, fontSize]);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);

  const midAdsConfig = {
    2: {
      mobile: { id: "div-gpt-ad-1680157855094-0", slot: "DH_MWeb_AT_Mid", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1680156704803-0", slot: "DH_Desktop_AT_Mid" }
    },
    4: {
      mobile: { id: "div-gpt-ad-1726651118047-0", slot: "DH_MWeb_AT_Mid02", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754393834239-0", slot: "DH_Desktop_AT_Mid02" }
    },
    6: {
      mobile: { id: "div-gpt-ad-1754032830774-0", slot: "DH_MWeb_AT_Mid03", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754393928790-0", slot: "DH_Desktop_AT_Mid03" }
    },
    8: {
      mobile: { id: "div-gpt-ad-1754033273317-0", slot: "DH_MWeb_AT_Mid04", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754393963082-0", slot: "DH_Desktop_AT_Mid04" }
    },
    10: {
      mobile: { id: "div-gpt-ad-1754033353593-0", slot: "DH_MWeb_AT_Mid05", storyPageAds: true },
      desktop: { id: "div-gpt-ad-1754394058619-0", slot: "DH_Desktop_AT_Mid05" }
    }
  };

  const updateCards = useMemo(() => getUpdatedCards(cards), [cards]);

  const [premiumCards, setPremiumCards] = useState(isPremiumStory && !isAdfree ? null : updateCards);

  useEffect(() => {
    if (!isPremiumStory || isAdfree || typeof window === "undefined") {
      setPremiumCards(updateCards);
      return;
    }

    setPremiumCards(getPremiumCards(updateCards));
  }, [updateCards, isAdfree, isPremiumStory]);

  useEffect(() => {
    const onScroll = throttle(() => {
      if (window.scrollY > 500) setRenderTaboolaAd(true);
    }, 300);

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const shouldHaveCardAds = ["listicle", "photo", "news-briefs"].includes(template) && !isAdfree;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
      if (typeof window === "undefined") return;
      const searchParams = new URLSearchParams(window.location.search);
      if (
        searchParams.has("access_token") &&
        searchParams.has("refresh_token")
      ) {
        setIsSSOCallback(true);
      }
    }, []);

    useLayoutEffect(() => {
      if (prevIsUserLoginRef.current !== isUserLogin && isSSOCallback) {
        prevIsUserLoginRef.current = isUserLogin;
        setIsAuthReloading(true);
        return;
      }

      prevIsUserLoginRef.current = isUserLogin;
    }, [isUserLogin, isSSOCallback]);

    useEffect(() => {
      if (!isAuthReloading || typeof window === "undefined") return;

      requestAnimationFrame(() => {
        if (isSSOCallback) {
          sessionStorage.setItem("sso_login_trigger_snackbar", "true");
        }
        window.location.reload();
      });
    }, [isAuthReloading, isSSOCallback]);

  useEffect(() => {
    if (!isPremiumStory || isAdfree || showLoader || !premiumCards) return;

    const measurePaywallPosition = () => {
      if (!contentRef.current) return;
      const container = contentRef.current;
      const WORD_LIMIT = 150;
      const textElements = container.querySelectorAll(".story-element-text, .question, .answer");

      if (textElements.length === 0) return;

      let wordCount = 0;
      let targetTextNode = null;
      let targetCharOffset = 0;
      let fallbackEl = null;
      let found = false;

      // Find the text node containing the 150th word
      for (let i = 0; i < textElements.length && !found; i++) {
        const textEl = textElements[i];
        const walker = document.createTreeWalker(textEl, NodeFilter.SHOW_TEXT, null);
        let node;
        while ((node = walker.nextNode()) && !found) {
          const text = node.textContent || "";
          const words = text.match(/\S+/g);
          if (!words) continue;
          if (wordCount + words.length >= WORD_LIMIT) {
            targetTextNode = node;
            fallbackEl = textEl;
            const remaining = WORD_LIMIT - wordCount;
            let idx = 0;
            let wIdx = 0;
            while (wIdx < remaining && idx < text.length) {
              while (idx < text.length && /\s/.test(text[idx])) idx++;
              while (idx < text.length && /\S/.test(text[idx])) idx++;
              wIdx++;
            }
            targetCharOffset = idx;
            found = true;
          } else {
            wordCount += words.length;
          }
        }
      }

      if (!found) {
        setClipHeight(null);
        return;
      }

      const containerRect = container.getBoundingClientRect();

      try {
        const range = document.createRange();
        const start = Math.max(0, targetCharOffset - 1);
        const end = Math.max(start + 1, targetCharOffset);
        if (end <= targetTextNode.length) {
          range.setStart(targetTextNode, start);
          range.setEnd(targetTextNode, end);
          const rect = range.getBoundingClientRect();
          if (rect && rect.bottom > containerRect.top) {
            setClipHeight(Math.round(rect.bottom - containerRect.top));
            return;
          }
        }
      } catch (e) {
        // fall through to element-level fallback
      }

      if (fallbackEl) {
        const elRect = fallbackEl.getBoundingClientRect();
        if (elRect.bottom > containerRect.top) {
          setClipHeight(Math.round(elRect.bottom - containerRect.top));
        }
      }
    };

    // Initial measurement
    measurePaywallPosition();

    // Measure using ResizeObserver to handle reflows
    let observer;
    const targetRef = innerContentRef.current || contentRef.current;
    if (window.ResizeObserver && targetRef) {
      observer = new ResizeObserver(() => {
        measurePaywallPosition();
      });
      observer.observe(targetRef);
    }

    // Always add window resize fallback and timeouts
    const timer1 = setTimeout(measurePaywallPosition, 100);
    const timer2 = setTimeout(measurePaywallPosition, 400);
    window.addEventListener("resize", measurePaywallPosition);

    // Fix for initial load: recalculate after custom web fonts finish loading
    if (document.fonts) {
      document.fonts.ready.then(() => measurePaywallPosition());
    }

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      window.removeEventListener("resize", measurePaywallPosition);
      if (observer) observer.disconnect();
    };
  }, [isPremiumStory, isAdfree, premiumCards, showLoader]);

  useEffect(() => {
    const handleReadMoreLogic = () => {
      if (!storyContentRef.current) return;

      if (isPremiumStory && !isAdfree) {
        setShouldShowReadMore(false);
        setIsExpanded(true);
        return;
      }

      const firstAd = document.getElementById("FirstAdContainer");
      if (!firstAd) {
        setShouldShowReadMore(false);
        return;
      }

      const isMetered = ["dh-exclusive", "text", "syndicated"].includes(template);
      const count = getArticlesRemaining();
      const isSafeToDeploy = !isMetered || count === null || count === -1 || count >= 1;

      if (!isSafeToDeploy) {
        setShouldShowReadMore(false);
        setIsExpanded(true);
        return;
      }

      const contentHeight = storyContentRef.current.scrollHeight;
      const adOffsetTop = firstAd.offsetTop + (isMobile ? (shouldHaveCardAds ? 430 : 440) : 440);

      setShouldShowReadMore(contentHeight > adOffsetTop);

      if (!isExpanded) {
        setStoryContentMaxHeight(adOffsetTop);
      }
    };

    const raf = requestAnimationFrame(() => setTimeout(handleReadMoreLogic, 250));
    return () => cancelAnimationFrame(raf);
  }, [updateCards, isExpanded, isMobile, template, shouldHaveCardAds, isPremiumStory, isAdfree, showLoader]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const search = window.location.search;
      const shouldShowFromStorage = sessionStorage.getItem("sso_login_trigger_snackbar") === "true";

      if ((search.includes("access_token") || shouldShowFromStorage) && isPremiumStory && isAdfree) {
        setTimeout(() => {
          window.dispatchEvent(
            new CustomEvent("show-snackbar", {
              detail: { type: "info", message: "You already have an active Subscription!" }
            })
          );
        }, 800);
      }

      if (shouldShowFromStorage) {
        sessionStorage.removeItem("sso_login_trigger_snackbar");
      }
    }
  }, [isAdfree, isPremiumStory]);


  const isExclusiveStory = template === "dh-exclusive";
  // determine if this story should show the election brick wall and choose data
  const rawSlug = story?.slug || "";
  let showBrickWallStoryPage = false;
  let brickStateName = "";
  let brickElectionSlugData = null;
  let brickYear = "2024";

  if (rawSlug.includes("elections/bihar")) {
    showBrickWallStoryPage = true;
    brickStateName = "BIHAR";
    brickElectionSlugData = assemblyElection2025SlugData_Bihar;
    brickYear = "2025";
  } else if (rawSlug.includes("elections/maharashtra")) {
    showBrickWallStoryPage = true;
    brickStateName = "MAHARASHTRA";
    brickElectionSlugData = assemblyElection2024SlugData;
  } else if (rawSlug.includes("elections/jharkhand")) {
    showBrickWallStoryPage = true;
    brickStateName = "JHARKHAND";
    brickElectionSlugData = assemblyElection2024SlugData;
  } else if (rawSlug.includes("elections/delhi")) {
    showBrickWallStoryPage = true;
    brickStateName = "DELHI";
    brickElectionSlugData = assemblyElection2024SlugData_Delhi;
  } else if (rawSlug.includes("elections/haryana")) {
    showBrickWallStoryPage = true;
    brickStateName = "HARYANA";
    brickElectionSlugData = assemblyElection2024SlugData_JK_HR;
  } else if (rawSlug.includes("elections/jammu-and-kashmir")) {
    showBrickWallStoryPage = true;
    brickStateName = "J&K";
    brickElectionSlugData = assemblyElection2024SlugData_JK_HR;
  }

  if (
    (isPremiumStory && (showLoader || premiumCards === null)) ||
    isSSOCallback ||
    isAuthReloading
  ) {
    return <SpinnerLoader />;
  }

  return (
    <div styleName={`wrapper ${isImmersiveStory ? "remove-margin" : ""}`} ref={mainRef}>
      {template === "movie-review" && <MovieReviewView story={story} />}
      {template === "gadget-review" && <GadgetReviewView story={story} />}
      {template === "book-review" && <BookReviewView story={story} />}

      <div styleName="relative-wrapper" id="story-relative-wrapper">
        <div
          id={`story-content-${story.id}`}
          className="story-cards taboola-read-more-container"
          ref={storyContentRef}
          style={{
            maxHeight: !isExpanded && storyContentMaxHeight ? `${storyContentMaxHeight}px` : "none",
            overflow: isExpanded ? "visible" : "hidden",
            transition: "max-height 0.3s ease"
          }}
        >
          <div
            ref={contentRef}
            style={
              isPremiumStory && !isAdfree && clipHeight
                ? { overflow: "hidden", maxHeight: `${clipHeight}px` }
                : {}
            }
          >
            <div ref={innerContentRef}>
            {(isPremiumStory && !isAdfree ? (premiumCards || []) : updateCards).map((card, cardIndex) => (
              <React.Fragment key={card.id}>
                {!isAdfree && shouldHaveCardAds && midAdsConfig[cardIndex] && (
                  <div id={cardIndex === 2 && template !== "photo" ? "FirstAdContainer" : ""}>
                    <div styleName="ad-wrapper" className="hide-desktop">
                      <AdContainer
                        storyPageAds={midAdsConfig[cardIndex].mobile.storyPageAds}
                        AdClassName="standard-336x280"
                        id={midAdsConfig[cardIndex].mobile.id}
                        mobile={midAdsConfig[cardIndex].mobile.slot}
                        cta={cardIndex < updateCards.length - 1 ? "inStory" : "sidebar"}
                      />
                      {cardIndex === 4 && isMobile && !isAdfree && (
                        <div
                          id="taboola-mid-article-personalisation"
                          styleName="taboola-4u"
                          ref={(el) => {
                            if (!el) return;

                            window._taboola = window._taboola || [];
                            window._taboola.push({
                              mode: "organic-thumbnails-mid-personalisation-mob",
                              container: "taboola-mid-article-personalisation",
                              placement: "Mid Article Personalisation",
                              target_type: "mix",
                            });
                            window._taboola.push({ flush: true });
                          }}
                        />
                      )}
                    </div>
                    <div styleName="ad-wrapper" className="hide-mobile">
                      <AdContainer
                        AdClassName="standard-336x280"
                        id={midAdsConfig[cardIndex].desktop.id}
                        desktop={midAdsConfig[cardIndex].desktop.slot}
                        cta={cardIndex < updateCards.length - 1 ? "inStory" : "sidebar"}
                      />
                      {cardIndex === 4 && !isMobile && !isAdfree && (
                        <div
                          id="taboola-mid-article-personalisation"
                          ref={(el) => {
                            if (!el) return;

                            window._taboola = window._taboola || [];
                            window._taboola.push({
                              mode: "organic-thumbnails-mid-personalisation-desk",
                              container: "taboola-mid-article-personalisation",
                              placement: "Mid Article Personalisation",
                              target_type: "mix",
                            });
                            window._taboola.push({ flush: true });
                          }}
                        />
                      )}
                    </div>
                  </div>
                )}
                <StoryCard
                  card={card}
                  story={story}
                  cardIndex={cardIndex}
                  index={index}
                  isNewTextStory={isNewTextStory}
                  adType={adType}
                  isMobile={isMobile}
                  isImmersiveStory={isImmersiveStory}
                  tempHideAd={tempHideAd}
                />
              </React.Fragment>
            ))}

            {!isImmersiveStory && (
              <>
                {isFactCheck && <FactCheckView story={story} />}
                {!sponsoredText && isSponsoredStory && (
                  <p styleName="story-note">Note: This is sponsored content curated by DH Brandspot.</p>
                )}
                {sponsoredText && (
                  <p styleName="story-note">
                    Note: This article is part of syndicated content curated by our partners.
                  </p>
                )}
                {isBrandspotNoAdStory && !isSpecificStory && (
                  <p styleName="story-note">
                    Note to readers: This article is part of Deccan Herald&apos;s paid consumer connect initiative. The
                    content is provided by the sponsor, and Deccan Herald is not responsible for errors, omissions, or
                    content accuracy.
                  </p>
                )}
                {isBrandspotClientStory && (
                  <p styleName="story-note">
                    Note: This is sponsored content. The views expressed here are solely those of the author.
                  </p>
                )}
                {!tempHideAd && !isAdfree && (
                  <div styleName="ad-wrapper" className="hide-desktop">
                    <AdContainer
                      AdClassName="standard-336x280"
                      id={adType === "izooto" ? "div-gpt-ad-1711972114719-0" : "div-gpt-ad-1680157888251-0"}
                      mobile={adType === "izooto" ? "DH_MWeb_AT_Bottom_ym" : "DH_MWeb_AT_Bottom"}
                      isExternalAdPath={adType === "izooto"}
                    />
                  </div>
                )}
                {showBrickWall && showBrickWallStoryPage && brickElectionSlugData && (
                  <ElectionBrickWall
                    stateName={brickStateName}
                    showStateTabs={false}
                    electionSlugData={brickElectionSlugData}
                    electionData={assemblyElection2024ConstituencyData}
                    year={brickYear}
                    showSeperator={false}
                  />
                )}
              </>
            )}
            </div>
          </div>

          {isPremiumStory && !isAdfree && <PaywallCard story={story} />}
          {!isExclusiveStory && <PublishedAt story={story} />}
          <Tags story={story} />
          <PromotionalMessage story={story} />
          <SubscribeCard story={story} />
        </div>

        {(!isPremiumStory || isAdfree) && <div styleName={`read-more-overlay ${!isExpanded && shouldShowReadMore ? "visible" : ""}`}>
          <button styleName="read-more-button" onClick={() => { setIsExpanded(true); window.dispatchEvent(new CustomEvent("dh-content-expanded")); }}>
            Read More <DownArrow color="white" height="8px" width="14px" />
          </button>
        </div>
        }
      </div>

      {!isImmersiveStory && renderTaboolaAd && !isAdfree && (
        <TaboolaAd
          container={`taboola-below-article-${story.id}`}
          placement={`Below ${template === "video" ? "Video" : template === "photo" ? "Photo" : "Article"} Thumbnails`}
          mode="thumbnails-b"
        />
      )}
    </div>
  );
};

StoryElements.defaultProps = {
  isFactCheck: false,
  isMovieReview: false,
  isGadgetReview: false,
  isSponsoredStory: false,
  isBrandspotClientStory: false,
  isImmersiveStory: false,
  isNewTextStory: false,
  isBookReview: false
};

export default StoryElements;
